import Hero from "../components/Hero";
import Features from "../components/Features";
import HowItWorks from "../components/HowItWorks";
import ForgotPasswordPage from "./ForgotPasswordPage";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/10 to-white flex flex-col items-center justify-start px-4 sm:px-6 md:px-8 py-8 sm:py-12 md:py-16">
      <div className="w-full max-w-7xl flex flex-col gap-12">
        <Hero />
        <Features />
        <HowItWorks />
      </div>
    </div>
  );
};

export default LandingPage; 